(() => {
  const initialize = (root) => {
    if (!root || root.dataset.btoReady === 'true') return;
    root.dataset.btoReady = 'true';
    document.documentElement.classList.add('bto-home-document');
    document.body.classList.add('bto-home-template');

    const legacyOverlaySelector = [
      
      '#voice-bot-wrapper', '#voice-bot-panel', '#tidio-chat', '#codex-tidio-close',
      '.codex-widget-close', '#zooomysalespop'
    ].join(',');
    const removeLegacyOverlays = () => document.querySelectorAll(legacyOverlaySelector).forEach((element) => element.remove());
    removeLegacyOverlays();
    if (!window.btoHomeOverlayObserver) {
      window.btoHomeOverlayObserver = new MutationObserver(removeLegacyOverlays);
      window.btoHomeOverlayObserver.observe(document.body, { childList: true, subtree: true });
    }

    const isPreview = /[?&]preview_theme_id=/.test(window.location.search) || Boolean(window.Shopify?.designMode);
    if (isPreview && !document.head.querySelector('meta[data-bto-home-robots]')) {
      const robots = document.createElement('meta');
      robots.name = 'robots';
      robots.content = 'noindex,nofollow';
      robots.dataset.btoHomeRobots = 'true';
      document.head.appendChild(robots);
    }

    const underline = root.querySelector('.bto-home-hero h1 em');
    if (underline) {
      const reveal = () => underline.classList.add('bto-home-underlineVisible');
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) return;
          reveal();
          observer.disconnect();
        }, { threshold: .55 });
        observer.observe(underline);
      } else reveal();
    }

    root.querySelectorAll('.bto-home-mobileMenu a').forEach((link) => link.addEventListener('click', () => {
      link.closest('details')?.removeAttribute('open');
    }));

    const dock = root.querySelector('[data-home-dock]');
    const storageKey = 'bella-terra-find-oil-dismissed';
    if (dock && window.sessionStorage.getItem(storageKey) === 'true') dock.remove();
    dock?.querySelector('[data-home-dock-close]')?.addEventListener('click', () => {
      window.sessionStorage.setItem(storageKey, 'true');
      dock.remove();
    });
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('.bto-home-page')) initialize(scope);
    scope.querySelectorAll?.('.bto-home-page').forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
